module.exports = __webpack_public_path__ + "img/universal_realistic.adbdc5df.png";